import { Identifiable, StrategicAxis } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type Response = {
  _embedded: {
    strategicAxeses: Identifiable<StrategicAxis>[];
  };
};

function getStrategicAxes(httpClient: HttpClient) {
  return () =>
    new Promise<Identifiable<StrategicAxis>[]>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Response>({
          endpoint: "/strategicAxeses",
          method: HttpMethods.GET,
        })
        .then(({ _embedded }) => (_embedded ? _embedded.strategicAxeses : []))
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { getStrategicAxes };
